

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { TextField, Button, Typography, CircularProgress, Box, InputAdornment, Paper } from "@mui/material";
import { AccountCircle, Lock } from "@mui/icons-material";
import axios from "axios";
import "./LoginRegister.css";
import APIURL from "../api/apiClient";

const LoginPage = ({ setSidebarVisible }) => {
  const [employee_id, setEmployee_id] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (setSidebarVisible) setSidebarVisible(false);
    return () => setSidebarVisible && setSidebarVisible(true);
  }, [setSidebarVisible]);

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setIsLoading(true);
  //   setErrorMessage("");

  //   if (!employee_id || !password) {
  //     setErrorMessage('Please fill in both fields.');
  //     setIsLoading(false);
  //     return;
  //   }

  //   try {
  //     const response = await axios.post(APIURL.getFullUrl('login.php'),
  //       { employee_id, password },
  //       {
  //         withCredentials: true,
  //         headers: { 'Content-Type': 'application/json' }
  //       }
  //     );

  //     if (response.data.success) {
  //       navigate('/home', { replace: true });
  //     } else {
  //       setErrorMessage(response.data.message || 'Invalid credentials.');
  //     }
  //   } catch (error) {
  //     if (error.response) {
  //       setErrorMessage(error.response.data.message || 'Login failed. Please try again.');
  //     } else if (error.request) {
  //       setErrorMessage('Network error. Please check your connection.');
  //     } else {
  //       setErrorMessage('An error occurred. Please try again.');
  //     }
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

    const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setIsLoading(true);

    if (!employee_id || !password) {
      setErrorMessage("Please fill in both fields.");
      setIsLoading(false);
      return;
    }

    try {
      const response = await axios.post(
        APIURL.getFullUrl("login.php"),
        { employee_id, password },
        {
          withCredentials: true,
          headers: { "Content-Type": "application/json" },
        }
      );

      const data = response.data;

      if (data.success) {
        const { role, employee_name, employee_id } = data;

        // Store session info
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("employee_id", employee_id);
        localStorage.setItem("employee_name", employee_name);
        localStorage.setItem("userRole", role);

        // Redirect based on role
        if (role === "staff") {
          navigate("/staffscreen", { replace: true });
        } else {
          navigate("/home", { replace: true });
        }
      } else {
        setErrorMessage(data.message || "Invalid credentials.");
      }
    } catch (error) {
      if (error.response) {
        setErrorMessage(error.response.data.message || "Login failed. Please try again.");
      } else if (error.request) {
        setErrorMessage("Network error. Please check your connection.");
      } else {
        setErrorMessage("An unexpected error occurred.");
      }
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="login_container">
      <div className="login template d-flex justify-content-center align-items-center vh-100">
        <Paper elevation={6} className="form_container">
          <form onSubmit={handleSubmit}>
            <Typography variant="h4" align="center" gutterBottom>
              Employee Login
            </Typography>

            <Box mb={3}>
              <TextField
                fullWidth
                label="Employee ID"
                variant="outlined"
                value={employee_id}
                onChange={(e) => setEmployee_id(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AccountCircle />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>

            <Box mb={3}>
              <TextField
                fullWidth
                type="password"
                label="Password"
                variant="outlined"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Lock />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>

            <Box className="d-grid" mb={2}>
              <Button
                variant="contained"
                fullWidth
                color="primary"
                type="submit"
                disabled={isLoading}
                style={{ padding: "12px 0", fontWeight: 600 }}
              >
                {isLoading ? <CircularProgress size={24} color="inherit" /> : "Login"}
              </Button>
            </Box>

            {errorMessage && (
              <Box className="alert alert-danger" mt={2}>
                {errorMessage}
              </Box>
            )}
          </form>
        </Paper>
      </div>
    </div>
  );
};

export default LoginPage;
